// eslint-disable-next-line import/named
import { HOUR } from 'time-constants'

export const AUTH_COOKIE_NAME = 'appSession'
export const AUTH_COOKIE_MAX_AGE_BUFFER = 2 * HOUR
